import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SyncItemTypesToZohoMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type SyncItemTypesToZohoMutation = { __typename?: 'Mutation', syncItemTypesToZoho: boolean };


export const SyncItemTypesToZohoDocument = gql`
    mutation SyncItemTypesToZoho($ids: [Int!]!) {
  syncItemTypesToZoho(ids: $ids)
}
    `;
export type SyncItemTypesToZohoMutationFn = Apollo.MutationFunction<SyncItemTypesToZohoMutation, SyncItemTypesToZohoMutationVariables>;

/**
 * __useSyncItemTypesToZohoMutation__
 *
 * To run a mutation, you first call `useSyncItemTypesToZohoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncItemTypesToZohoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncItemTypesToZohoMutation, { data, loading, error }] = useSyncItemTypesToZohoMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSyncItemTypesToZohoMutation(baseOptions?: Apollo.MutationHookOptions<SyncItemTypesToZohoMutation, SyncItemTypesToZohoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncItemTypesToZohoMutation, SyncItemTypesToZohoMutationVariables>(SyncItemTypesToZohoDocument, options);
      }
export type SyncItemTypesToZohoMutationHookResult = ReturnType<typeof useSyncItemTypesToZohoMutation>;
export type SyncItemTypesToZohoMutationResult = Apollo.MutationResult<SyncItemTypesToZohoMutation>;
export type SyncItemTypesToZohoMutationOptions = Apollo.BaseMutationOptions<SyncItemTypesToZohoMutation, SyncItemTypesToZohoMutationVariables>;